import React from 'react'
import styled from '@emotion/styled'
import ThemeConsumer from '@/hoc/ThemeConsumer'
import Typography from '@/components/common/Typography'
import { rem } from '@/utils/helpers'

const Template = props => {
  const { theme, title, link, tags, body, ...others } = props
  return (
    <Root {...others}>
      <Head theme={theme}>
        <Title variant="h2" component="h3">{title}</Title>
        <Link variant="caption" lang="en" component="a" theme={theme} href={link} target="_blank" rel="noopener noreferrer">
          <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M3.33278 12.5732C3.33278 12.9399 3.63278 13.2399 3.99945 13.2399H11.9995C12.3661 13.2399 12.6661 12.9399 12.6661 12.5732V9.23991C12.6661 8.87324 12.9661 8.57324 13.3328 8.57324C13.6995 8.57324 13.9995 8.87324 13.9995 9.23991V13.2399C13.9995 13.9732 13.3995 14.5732 12.6661 14.5732H3.33278C2.59945 14.5732 1.99945 13.9732 1.99945 13.2399V3.90658C1.99945 3.17324 2.59278 2.57324 3.33278 2.57324H7.33278C7.69945 2.57324 7.99945 2.87324 7.99945 3.23991C7.99945 3.60658 7.69945 3.90658 7.33278 3.90658H3.99945C3.63278 3.90658 3.33278 4.20658 3.33278 4.57324V12.5732ZM9.99946 3.90658C9.63279 3.90658 9.33279 3.60658 9.33279 3.23991C9.33279 2.87324 9.63279 2.57324 9.99946 2.57324H13.3328C13.6995 2.57324 13.9995 2.87324 13.9995 3.23991V6.57324C13.9995 6.93991 13.6995 7.23991 13.3328 7.23991C12.9661 7.23991 12.6661 6.93991 12.6661 6.57324V4.84658L6.57946 10.9332C6.31946 11.1932 5.89946 11.1932 5.63946 10.9332C5.37946 10.6732 5.37946 10.2532 5.63946 9.99324L11.7261 3.90658H9.99946Z" fill="currentColor"/>
          </svg>
          {link}
        </Link>
      </Head>
      <Tags>
        {tags.map((tag, index) => (
          <Tag theme={theme} variant="caption" component="li" key={index}>{tag}</Tag>
        ))}
      </Tags>
      <Body variant="body3">{body}</Body>
    </Root>
  )
}

export default ThemeConsumer(Template)

const Root = styled.div`
`

const Head = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: ${rem(16)};
  border-bottom: 1px solid ${props => props.theme.gray.d};
`

const Title = styled(Typography)``

const Link = styled(Typography)`
  display: flex;
  align-items: center;
  color: ${props => props.theme.gray.e};

  svg {
    width: ${rem(16)};
    height: ${rem(17)};
    margin-right: ${rem(8)};
  }
`

const Tags = styled.ul`
  margin-top: ${rem(8)};
  display: flex;
  flex-wrap: wrap;
  margin-left: ${rem(-8)};
`

const Tag = styled(Typography)`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: ${rem(8)};
  margin-left: ${rem(8)};
  padding: 0 ${rem(12)};
  height: ${rem(24)};
  border-radius: ${rem(100)};
  border: 1px solid ${props => props.theme.gray.d};
`

const Body = styled(Typography)`
  margin-top: ${rem(24)};
`
